import { Badge } from "@chakra-ui/react";

const INTEREST_LEVEL_STYLES = {
    Low: { bg: "gray.600", borderColor: "gray.400", label: "Niskie" },
    Medium: { bg: "orange.600", borderColor: "orange.300", label: "Średnie" },
    High: { bg: "green.600", borderColor: "green.300", label: "Wysokie" },
};

export const LeadInterestLevelBadge = ({ interestLevel, badgeStyles }) => {
    if (!interestLevel) return null;
    const { bg, borderColor, label } = INTEREST_LEVEL_STYLES[interestLevel] ?? { bg: "gray.600", borderColor: "gray.400", label: interestLevel };

    return (
        <Badge bg={bg} borderColor={borderColor} borderWidth={1} variant="subtle" fontSize="xs" px={3} py={0.5} borderRadius={6} {...badgeStyles}>
            {label}
        </Badge>
    );
};

export default LeadInterestLevelBadge;
